(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/omitBy', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/omitBy'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.omitBy, global.convert);
    global.omitBy = mod.exports;
  }
})(this, function (exports, _omitBy2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.omitBy = undefined;

  var _omitBy3 = _interopRequireDefault(_omitBy2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an object omitting properties that <code>predicate</code> doesn't return truthy for.
   * @function
   * @memberof object
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {function} [predicate={@link https://lodash.com/docs#identity|lodash.identity}] The function invoked per property.
   * @return {Object} Returns the updated object.
   * @example omitBy({ nested: { a: 1, b: 2, c: 3 } }, 'nested', v => v === 2) // => { nested: { a:1, c: 3 } }
   * @see {@link https://lodash.com/docs#omitBy|lodash.omitBy} for more information.
   * @since 0.3.0
   */
  var omitBy = (0, _convert.convert)(_omitBy3.default);
  exports.omitBy = omitBy;
  exports.default = omitBy;
});